import * as audio from './audio'

export default function autoplayAudio (mode, subMode, card, user, answer) {
  if (user.autoplayAudio) {
    audio.play(`/api/items/autoplay_audio?mode=${mode}&sub_mode=${subMode}&item_id=${card.item.id}&lesson_type=${card.lessonType}&answer=${answer}`)
  }
}
